import { render, staticRenderFns } from "./WorkflowStatusQuestionDeleteDialog.vue?vue&type=template&id=b5c993ea&scoped=true"
import script from "./WorkflowStatusQuestionDeleteDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowStatusQuestionDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatusQuestionDeleteDialog.vue?vue&type=style&index=0&id=b5c993ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c993ea",
  null
  
)

export default component.exports